export default __webpack_public_path__ + "static/media/VideoCall.sprite.09c3b174.mp3";